import { Popover } from "antd"
import LogFilter from "pages/Timesheet/LogFilter"
import React, { useState } from "react"

const TimesheetFilter = ({ data }) => {
  const [visible, setVisible] = useState(false)

  const filterContent = (
    <div>
      <div className=" px-4 pt-2" style={{ maxWidth: "1000px" }}>
        <LogFilter
          status_options={data?.status_options || []}
          logs={data?.table_data || []}
          setLogs={data?.settable_data}
          all_logs={data?.all_tasks || []}
          all_services={data?.all_services || []}
          calculateTimeDifference={data?.calculateTimeDifference || false}
          emp_options={data?.emp_options || []}
          taskName_options={data.taskName_options || []}
          clientName_options={data.clientName_options || []}
          clientCode_options={data.clientCode_options || []}
          type={data?.type || ""}
          setVisible={setVisible}
        />
      </div>
    </div>
  )

  return (
    <Popover
      placement="bottomLeft"
      content={filterContent}
      title={`Filter ${data?.type == "task" ? "Tasks" : "Timesheet"} Records`}
      trigger="click"
      visible={visible}
      onVisibleChange={visible => setVisible(visible)}
    >
      <button className="btn btn-outline-primary ms-3">
        <i className="fas fa-filter me-2"></i> Filter
      </button>
    </Popover>
  )
}

export default TimesheetFilter
